<template>
  <BaseLayout
      :breadcrumb="breadcrumb"
      className="articleDetail"
  >
    <div class="articleDetail__header" v-if="currentArticle">
      <div class="container container--sm">
        <img :src="currentArticle.image" alt="" width="480" height="320" loading="lazy">
        <div class="articleDetail__header-content">
          <h1>{{ currentArticle.title }}</h1>
          <div class="articleDetail__header-content__panel">
            <time :datetime="machineDateFormat(this.currentArticle.date_created)">{{ dateFormat(this.currentArticle.date_created) }}</time>
            <p>{{ translation('article_detail-author') }}: {{ currentArticle.created_by.firstname }} {{ currentArticle.created_by.lastname }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="articleDetail__content" ref="content">
      <div class="container container--xxs mt-6 mt-lg-9 mb-12 mb-lg-18" v-if="currentArticle">
        <SocialShare
            :title="currentArticle.title"
            :moved="false"
            className="articleDetail__share mb-3 mb-lg-0"
        />
        <p class="articleDetail__lead" v-html="currentArticle.lead"/>
        <div class="articleDetail__text" v-html="currentArticle.content"/>
      </div>

      <img
          v-if="showParticle[0]"
          src="../assets/images/particles/laptop.svg"
          alt=""
          class="articleDetail__particle articleDetail__particle--0"
          width="348"
          height="290"
          loading="lazy"
      >
      <img
          v-if="showParticle[1]"
          src="../assets/images/particles/certificate.svg"
          alt=""
          class="articleDetail__particle articleDetail__particle--1"
          width="315"
          height="267"
          loading="lazy"
      >
      <img
          v-if="showParticle[2]"
          src="../assets/images/particles/briefcase.svg"
          alt=""
          class="articleDetail__particle articleDetail__particle--2"
          width="430"
          height="401"
          loading="lazy"
      >
    </div>
    <div class="articleDetail__related py-3 py-6" v-if="relatedArticle">
      <div class="container container--xxs">
        <p class="articleDetail__related-title mb-3">{{translation('article_detail-related')}}</p>
        <ArticleSmallCard :data="relatedArticle"/>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import ArticleSmallCard from "@/components/ArticleSmallCard";
import BaseLayout from "@/components/BaseLayout";
import SocialShare from "@/components/SocialShare.vue";
import codeBooksMixin from "@/mixins/codeBooksMixin";
import formatMixins from "@/mixins/formatMixins";
import {blogService} from "@/services/blog.service";
import store from "@/store";
import {mapState} from "vuex";

export default {
  data() {
    return {
      showParticle: {
        0: false,
        1: true,
        2: false
      },
      currentArticle: null,
      relatedArticle: null,
    }
  },
  async created() {
    try {
      const response = await blogService.getArticle(this.articleId);
      this.currentArticle = response.data;
      this.relatedArticle = response.data.next_article;
      sessionStorage.setItem('lastPage', '/blog/' + this.currentArticle.url);
    } catch (err) {
      store.dispatch('app/addFlashMessage', {message: this.translation('global_alert-general')})
    }
  },
  computed: {
    ...mapState("page", {
      articleId: (state) => state.pageId,
    }),
    breadcrumb() {
      let out = [{
        title: this.translation('header_nav_link-blog'),
        url: '/blog',
      }];

      if (this.currentArticle) {
        out.push({
          title: this.currentArticle.title,
          url: '/blog/' + this.currentArticle.url,
        })
      }
      return out;
    }
  },
  updated() {
    // check page content height and if there is space show particles
    setTimeout(() => {
      if (this.currentArticle) {
        this.showParticle[0] = this.$refs.content.offsetHeight > 800;
        this.showParticle[2] = this.$refs.content.offsetHeight > 1200;
      }
    }, 100)
  },
  mixins: [codeBooksMixin, formatMixins],
  components: {
    SocialShare,
    ArticleSmallCard,
    BaseLayout
  },
}
</script>